export const poolShapes = {
  rectangle: 0,
  round: 1,
  oval: 2,
  kidney: 3,
};

export const poolShapeLabelIDs = {
  [poolShapes.rectangle]: 'quick-calcs.pool-volume.rectangle',
  [poolShapes.round]: 'quick-calcs.pool-volume.round',
  [poolShapes.oval]: 'quick-calcs.pool-volume.oval',
  [poolShapes.kidney]: 'quick-calcs.pool-volume.kidney',
};

export function inRange(num) {
  try {
    const n = parseFloat(num);

    return n >= 1 && n <= 999;
  } catch(err) {
    return false;
  }
}
